// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ln28V","row":"styles_row__RHCf9"};